<template>
    <div class="load-mask-parent">
        <div :class="loadMask"></div>
        <div class="title-box" v-if="moduleConfig">
            <div class="title-box-wrapper">
                <span class="title">{{ moduleConfig.title }}</span>
                <span class="icon icon-help"
                      v-show="moduleConfig && moduleConfig.description"
                      @mouseover="moduleDescriptionShow = true"
                      @mouseleave="moduleDescriptionShow = false"
                >
                </span>
                <toggle-button class="pull-right"
                               v-if="getFilters.length"
                               @change="moduleConfig.filterShow=!moduleConfig.filterShow"
                               :sync="true"
                               :value="!moduleConfig.filterShow" :height="25" :width="90"
                               :labels="{checked: t('Show filters'), unchecked: t('Hide filters')}"
                />
                <filter-value class="pull-right"
                              v-if="getFilters.length"
                              :event-bus="$root"
                              :routeName="$route.name"
                              :component-filter-index="'ToggleFilterPanel'"
                />
            </div>
        </div>
        <div class="title-box" v-show="moduleDescriptionShow">
            <div class="description-box-wrapper">
                <span class="title" v-html="moduleConfig.description">{{
                        moduleConfig && moduleConfig.description
                    }}</span>
            </div>
        </div>

        <!-- Filter section -->
        <toggle-filter-panel v-show="moduleConfig.filterShow"
                             :filters="getFilters"
                             :component-index="getComponentIndex"
                             :routeName="$route.name"
                             :module-config="moduleConfig"
        ></toggle-filter-panel>

        <br/>

        <template v-for="(component, index) in moduleConfig.components || []">
            <div class="bg">
                <div class="inner clearfix">
                    <component
                        :is="component.type"
                        :config="component"
                        :index="index"
                        :moduleConfig="moduleConfig"
                        :routeName="$route.name"
                        :row-index="rowIndex"
                        :eventBus="$root"
                    ></component>
                </div>
            </div>
            <br/>
            <div class="clearfix"></div>
        </template>
        <Modal
            v-show="isModalVisible"
            @close="closeModal"
            :eventBus="$root"
        >
        </Modal>
    </div>
</template>

<script>

import Vue from 'vue';
import ToggleButton from 'vue-js-toggle-button';
import ToggleFilterPanel from "../../components/ToggleFilterPanel";
import chart from "../../components/Chart";
import chartRadar from "../../components/ChartRadarComponent";
import chartCanvas from "../../components/ChartCanvasComponent";
import canvasChart from "../../components/CanvasChart";
import grid from "../../components/Grid";
import productInfoComponent from "../../components/ProductInfoComponent";
import formComponent from "../../components/FormComponent";
import dynamicPricingRule from "../../components/DynamicPricingRuleComponent";
import attributesComponent from "../../components/AttributesComponent";
import MapComponent from "../../components/MapComponent";
import Modal from "../../components/modal/Modal";
import QueryString from "../../services/parser/QueryString";
import FilterValue from "../../components/FilterValue";
import Component from "../../services/components/Component.ts";
import ValueChecker from "../../services/ValueChecker";

Vue.use(ToggleButton);

export default {
    components: {
        FilterValue,
        ToggleFilterPanel,
        grid,
        chart,
        chartRadar,
        chartCanvas,
        productInfoComponent,
        attributesComponent,
        formComponent,
        dynamicPricingRule,
        canvasChart,
        MapComponent
        , Modal
    },
    props: {
        route: {
            Type: Object
        },
        rowIndex: {
            Type: Number
        },
    },
    data() {
        return {
            events: [],
            moduleDescriptionShow: false,
            moduleConfig: {},
            filters: [],
            mounted: false,
            loadMask: '',
            isModalVisible: false,
            state: {},
        };
    },
    inject: ['eventSourceService'],
    mounted() {
        this.setState();
        this.init();
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    computed: {
        getComponentIndex() {
            let components = this.moduleConfig.components || [];
            let componentIndex = null;
            components.some(c => {
                if (c.filters && c.filters.length > 0) {
                    componentIndex = c.index;
                }
            });

            return componentIndex;
        },
        getFilters() {
            if (this.filters.length > 0) {
                return this.filters;
            }

            let components = this.moduleConfig.components || [];
            components.some(c => {
                if (c.filters && c.filters.length > 0) {
                    this.filters = c.filters;

                    return true;
                }

                return false;
            });

            return this.filters;
        },
    },
    methods:
        {
            closeModal() {
                this.isModalVisible = false;
            },
            registerComponents(components) {
                let componentService = this.$root.getComponentService();
                components.forEach((v) => {
                    if (componentService.has(v.index)) {
                        return;
                    }

                    componentService.add(v.index, new Component(v));
                });
            },
            getModuleIndex() {
                if (!ValueChecker.isUndefinedOrNull(this.state['rowIndex'])) {
                    return `${this.moduleConfig.moduleName}${this.state['rowIndex']}`;
                }

                return `${this.moduleConfig.moduleName}`;
            },
            init(callback) {
                if (this.mounted) {
                    return;
                }

                this.loadMask = 'lmask';
                this.mounted = true;
                let params = {};

                for (const key of Object.keys(this.$route.params)) {
                    if (this.$route.matched[0].path.includes(':' + key)) {
                        params[key] = this.$route.params[key];
                    }
                }

                let query = QueryString.encodeWithBracket(this.$route.query);

                this.$http.get(this.$route.name + '/init?' + query, {params: params}).then(response => {
                    this.registerComponents(response.data.moduleConfig.components || []);
                    let components = (response.data.moduleConfig.components || []).filter(v => {
                        return (v.display || '') !== 'modal';
                    });
                    response.data.moduleConfig.components = components;

                    this.moduleConfig = response.data.moduleConfig;
                    this.loadAdditionalFile(this.moduleConfig.moduleName);

                    if (typeof callback === 'function') {
                        callback();
                    }

                    this.loadMask = '';
                });
            },
            loadAdditionalFile(moduleName) {
                let files = ['index'];
                const lazyLoading = (path) => {
                    return (resolve, reject) => {
                        return require([`./../../modules/${path}.vue`], resolve, reject)
                    }
                };

                files.forEach((fileName) => {
                    lazyLoading(moduleName + '/' + fileName)((t) => {
                        let comp = Vue.extend(t);
                        let component = new comp({
                            propsData: {
                                root: this.$root,
                                route: this.$route,
                                moduleConfig: this.moduleConfig,
                                eventSourceService: this.eventSourceService,
                            }
                        });
                        component.$mount();
                        this.mountEvents();
                    }, (r) => {
                        this.mountEvents();
                    });
                });
            },
            mountEvents() {
                let moduleIndex = this.getModuleIndex();
                let customModuleEventName = `${moduleIndex}:ready`;

                this.$root.$emit('CustomModule:ready', customModuleEventName, moduleIndex, this.moduleConfig, this.state);
                this.events.push('CustomModule:ready');

                this.$root.$emit(customModuleEventName, this.moduleConfig, this.state);
                this.events.push(customModuleEventName);
                setTimeout(() => {
                        this.$root.$emit(customModuleEventName + ':componentsReady', this.moduleConfig, this.state);
                        this.events.push(customModuleEventName + ':componentsReady');
                    },1000);

                this.$root.$on('show-modal-comp', (config, data) => {
                    this.isModalVisible = true;
                    this.$root.$emit('init-modal', config, data);
                    config.callback();
                });

                this.$root.$on('open-in-new-window', (config, data) => {
                    this.openInNewWindow(data.response);
                });
            },
            unmountEvents() {
                this.events.forEach(e => {
                    this.$root.$off(e);
                });

                this.$root.$off('show-modal-comp');
                this.$root.$off('open-in-new-window');
                this.$root.$off('open-in-new-window-modal-comp');
            },
            setState() {
                this.state = Object.assign(this.state, {query: this.$route.query}, {rowIndex: this.rowIndex});
            }
        }
}
</script>


<style lang="sass">
.load-mask-parent {
    min-height: 350px;

}
</style>



// WEBPACK FOOTER //
// index.vue?df309632